import axios from 'axios';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import UserContext from '../../contexts/UserContext';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const SupplyDispatch = () => {
  const location = useLocation();
  const { request, approvedItems } = location.state || {};
  const { user, setUser } = useContext(UserContext);
  const [message,setMessage] = useState('');
  const navigate = useNavigate();

  // Initial form state with default values
  const [formData, setFormData] = useState({
    comments: '',
    vehicleNo: '',
    address: approvedItems[0].zone.address || '',
    contact: ''
  });

  // Update form data state on change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Authenticate user on component mount
  useEffect(() => {
    const startup = async () => {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    };
    startup();
  }, [user, navigate, setUser]);

  // Handle form submission
  const submitSupplierForRequest = (e) => {
    e.preventDefault();

    // Prepare the final request object with dispatch details
    const finalObject = {
      request: {
        ...request,
        items: approvedItems.map(item => {
          // Determine if we should update supplier or zoneSupplier dispatch details
          const dispatchDetails = {
            comments: formData.comments,
            vehicleNo: formData.vehicleNo,
            contact: formData.contact,
            address: formData.address,
            dispatchedAt: new Date().toISOString() // Adding dispatch timestamp
          };

          if (item.supplier) {
            return {
              ...item,
              supplier: {
                ...item.supplier,
                dispatch: dispatchDetails
              },
              status: 'dispatched'
            };
          } else if (item.zoneSupplier) {
            return {
              ...item,
              zoneSupplier: {
                ...item.zoneSupplier,
                dispatch: dispatchDetails
              },
              status: 'dispatched'
            };
          } else {
            // If neither is available, just return the item (shouldn't happen in your use case)
            return item;
          }
        })
      }
    };

    // Post the dispatch details to the server
    axios.post(`${process.env.REACT_APP_API_URI}/api/supplier/updateDispatch`, finalObject, { withCredentials: true })
      .then((response) => {
        console.log(response.data);
        // Navigate back to the supplier home after successful submission
        setTimeout(() => {
          navigate('/central/supplyapproval');
        }, 1000);
      })
      .catch((err) => {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setMessage(errorMessage)
          }
      });
  };

  return (
    <>
      <div className="bg-lime-800 text-lime-100 p-4 w-full shadow-md flex items-center mb-4">
        <div className="mr-4 cursor-pointer" onClick={() => navigate(-1)}>
          <span className="text-xl">←</span>
        </div>
        <h4 className="text-lg md:text-xl font-semibold text-center flex-grow">Dispatch</h4>
      </div>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-4 lg:px-8">
      {message?
        <div class="bg-red-100 border border-red-300 text-red-500 px-4 py-3 mx-0 rounded relative" role="alert">
          <span class="block sm:inline">{message}</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          </span>
        </div>
        :null}
        <form className="space-y-6" onSubmit={submitSupplierForRequest}>
          <div>
            <label htmlFor="comments" className="block text-sm font-medium leading-6 text-gray-900">
              Comments
            </label>
            <div className="mt-2">
              <input
                id="comments"
                name="comments"
                type="text"
                placeholder='Comments'
                value={formData.comments}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="vehicleNo" className="block text-sm font-medium leading-6 text-gray-900">
              Vehicle Number
            </label>
            <div className="mt-2">
              <input
                id="vehicleNo"
                name="vehicleNo"
                type="text"
                placeholder='Vehicle Number'
                value={formData.vehicleNo}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="contact" className="block text-sm font-medium leading-6 text-gray-900">
              Contact
            </label>
            <div className="mt-2">
              <input
                id="contact"
                name="contact"
                type="text"
                placeholder='Contact'
                value={formData.contact}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="address" className="block text-sm font-medium leading-6 text-gray-900">
              Address
            </label>
            <div className="mt-2">
              <input
                id="address"
                name="address"
                type="text"
                placeholder='Address'
                value={formData.address}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-full text-white bg-fmb px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default SupplyDispatch;
